import React, { useContext, useEffect, useState } from "react";
import { apiValue2 } from "../Data/AllData";
import { Link } from "react-router";
import { useCart } from "react-use-cart";

function Phone() {
  const { addItem } = useCart();
  const [search, setsearch] = useState(0);
  const [favorites, setFavorites] = useState([]);
  const api2 = useContext(apiValue2);

  const getSearch2 = (event) => {
    setsearch(event.target.value);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(saved);
  }, []);

  const toggleFavorite = (product) => {
    const exists = favorites.some((fav) => fav.id === product.id);

    const updated = exists
      ? favorites.filter((fav) => fav.id !== product.id)
      : [...favorites, product];

    setFavorites(updated);
    localStorage.setItem("favorites", JSON.stringify(updated));
    window.dispatchEvent(new Event("favoritesUpdated"));
  };

  return (
    <div>
      <>
        {/* Start Content */}
        <div className="container py-5">
          <div className="row">
            <div className="dropdown col-md-2 mb-3">
              <button
                className="btn btn-success dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                select the section
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/phone">
                    phones
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/laptop">
                    laptops
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/shop">
                    product
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-10">
              <input
                onChange={getSearch2}
                className="form-control mb-5 col-md-12 w-100 "
                type="text"
                name="products"
                placeholder="search for product...."
              />
            </div>

            {api2.map((element2) => {
              const isFav = favorites.some((fav) => fav.id === element2.id);

              return search == 0 ? (
                <div className="col-md-4 rounded-5" key={element2.id}>
                  <div className="card mb-4 product-wap rounded-5">
                    <div className="card rounded-0">
                      <img
                        className="card-img rounded-5 py-3 img-fluid"
                        src={element2.images[0]}
                        alt={element2.title}
                      />
                      <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                        <ul className="list-unstyled">
                          <li>
                            <button
                              className="btn btn-success text-white"
                              onClick={() => toggleFavorite(element2)}
                            >
                              <i className="far fa-heart" />
                            </button>
                          </li>
                          <li>
                            <Link
                              className="btn btn-success text-white mt-2"
                              to={`/SinglePhone/${element2.id}`}
                            >
                              <i className="far fa-eye" />
                            </Link>
                          </li>
                          <li>
                            <button
                              onClick={() => addItem(element2)}
                              className="btn btn-success text-white mt-2"
                            >
                              <i className="fas fa-cart-plus" />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <Link
                        to={`/SinglePhone/${element2.id}`}
                        className="h3 text-decoration-none d-block text-white title-product m-auto"
                      >
                        <b>{element2.title}</b>
                      </Link>
                      <br />
                      <h4 className="text-center mb-0 text-success ">
                        ${element2.price}
                      </h4>
                    </div>
                  </div>
                </div>
              ) : element2.title
                  .toLowerCase()
                  .includes(search.toLowerCase()) ? (
                <div className="col-md-4 rounded-5" key={element2.id}>
                  <div className="card mb-4 product-wap rounded-5">
                    <div className="card rounded-0">
                      <img
                        className="card-img rounded-0 img-fluid py-3"
                        src={element2.images[0]}
                        alt={element2.title}
                      />
                      <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                        <ul className="list-unstyled">
                          <li>
                            <button
                              className="btn btn-success text-white"
                              onClick={() => toggleFavorite(element2)}
                            >
                              <i className="far fa-heart" />
                            </button>
                          </li>
                          <li>
                            <Link
                              className="btn btn-success text-white mt-2"
                              to={`/shopSingle/${element2.id}`}
                            >
                              <i className="far fa-eye" />
                            </Link>
                          </li>
                          <li>
                            <button
                              onClick={() => addItem(element2)}
                              className="btn btn-success text-white mt-2"
                            >
                              <i className="fas fa-cart-plus" />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <Link
                        to={`/SinglePhone/${element2.id}`}
                        className="h3 text-decoration-none d-block text-white title-product m-auto"
                      >
                        <b>{element2.title}</b>
                      </Link>
                      <b>
                        id: <b>{element2.id}</b>
                      </b>
                      <br />
                      <b>
                        brand: <b>{element2.brand}</b>
                      </b>
                      <br />
                      <b>
                        rating: <b>{element2.rating} of 5</b>
                      </b>
                      <br />
                      <h4 className="text-center mb-0 text-success ">
                        ${element2.price}
                      </h4>
                    </div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </div>
        {/* End Content */}
      </>
    </div>
  );
}

export default Phone;
